import dayjs from "dayjs";

export const TIMEZONE = "Europe/Paris";

export const WEEK_DAYS = ["Lun", "Mar", "Mer", "Jeu", "Ven"];

export const DAILY_HOURS_TARGET = 7;

export const normalizeDuration = (duration) => {
	if (typeof duration === "number") return duration;
	if (typeof duration === "string") {
		const normalized = duration.replace(",", ".");
		const parsed = parseFloat(normalized);
		return isNaN(parsed) ? 0 : parsed;
	}
	return 0;
};

export const formatDuration = (duration) => {
	const normalized = normalizeDuration(duration);
	if (Number.isInteger(normalized)) return normalized + " h";
	return normalized.toFixed(2) + " h";
};

export const getEntryId = (entry) => entry.tempId || entry.id;

export const normalizeString = (str) => {
	if (!str) return "";
	return str
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.toLowerCase()
		.replace(/[-_.,;:]/g, " ")
		.replace(/\s+/g, " ")
		.trim();
};

export const createTaskFilter = (sections, tasks) => (option, inputValue) => {
	if (!inputValue) return true;

	const searchValue = normalizeString(inputValue);
	const task = option.data;
	const section = sections.find((s) => s.id === task.sectionId);
	const parent = task.parentId ? tasks.find((t) => t.id === task.parentId) : null;

	if (normalizeString(task.name).includes(searchValue)) return true;
	if (section && normalizeString(section.name).includes(searchValue)) return true;
	return !!(parent && normalizeString(parent.name).includes(searchValue));
};

export const sortByCustomOrder = (a, b) => {
	const aOrder = typeof a.customOrder === "number" ? a.customOrder : Number.MAX_SAFE_INTEGER;
	const bOrder = typeof b.customOrder === "number" ? b.customOrder : Number.MAX_SAFE_INTEGER;
	return aOrder - bOrder;
};

export const sortByKey = (a, b, key, direction, projects) => {
	let aValue, bValue;

	switch (key) {
		case "date": {
			const aDate = dayjs(a.date).valueOf();
			const bDate = dayjs(b.date).valueOf();
			if (aDate !== bDate) return direction === "asc" ? aDate - bDate : bDate - aDate;
			if (a.createdAt && b.createdAt) {
				const aCreated = dayjs(a.createdAt).valueOf();
				const bCreated = dayjs(b.createdAt).valueOf();
				return direction === "asc" ? aCreated - bCreated : bCreated - aCreated;
			}
			const aTie = Number(a.tempId || a.id);
			const bTie = Number(b.tempId || b.id);
			return direction === "asc" ? aTie - bTie : bTie - aTie;
		}
		case "project": {
			const projectA = projects.find((p) => p.id === a.projectId);
			const projectB = projects.find((p) => p.id === b.projectId);
			aValue = projectA ? projectA.name.toLowerCase() : "";
			bValue = projectB ? projectB.name.toLowerCase() : "";
			break;
		}
		case "task":
			aValue = a.task?.name?.toLowerCase() || "";
			bValue = b.task?.name?.toLowerCase() || "";
			break;
		case "comments":
			aValue = (a.comments || "").toLowerCase();
			bValue = (b.comments || "").toLowerCase();
			break;
		case "duration":
			aValue = normalizeDuration(a.duration);
			bValue = normalizeDuration(b.duration);
			break;
		default:
			return 0;
	}

	if (aValue < bValue) return direction === "asc" ? -1 : 1;
	if (aValue > bValue) return direction === "asc" ? 1 : -1;
	return 0;
};

export const calculateTotalDuration = (entries) => {
	return entries.reduce((sum, entry) => {
		if (entry.tempId) return sum;
		return sum + normalizeDuration(entry.duration);
	}, 0);
};
